// Modo claro u oscuro, elegido en la cabecera (decisión D49). Por defecto claro; queda guardado en el dispositivo. El
// arranque de index.html lo aplica antes de pintar para que no parpadee. Los colores del modo oscuro van en estilos.css
// y en la escala de la marca (datos/color.ts), bajo `[data-tema=oscuro]`.
import { create } from 'zustand';
import { guardar, leer } from './almacen';

export type Tema = 'claro' | 'oscuro';

/** La misma para todas las tiendas del navegador: es una preferencia de la persona, no de la empresa. */
export const CLAVE_TEMA = 'tienda:tema';

export const temaGuardado = (): Tema => (leer<string>(CLAVE_TEMA) === 'oscuro' ? 'oscuro' : 'claro');

export function aplicarTema(t: Tema): void {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.tema = t;
  document.documentElement.style.colorScheme = t === 'oscuro' ? 'dark' : 'light';
}

export const useTema = create<{ tema: Tema }>(() => ({ tema: temaGuardado() }));

export function elegirTema(t: Tema): void {
  guardar(CLAVE_TEMA, t);
  aplicarTema(t);
  useTema.setState({ tema: t });
}

export const alternarTema = () => elegirTema(useTema.getState().tema === 'oscuro' ? 'claro' : 'oscuro');

aplicarTema(useTema.getState().tema);
